/**
 * Created by rhinov12 on 04/12/2015.
 */

import { ActionStateEnum } from "../../state/actionState/ActionState";
import { GameObjectManager } from "../GameObjectManager";
import { PlanManager } from "../../../../cocosPlan";
import { Events, eventsManager } from "@rhinov/savane-js";

declare var cc: any;

export class DimensionNode extends cc.DrawNode {
    constructor(color: any = null) {
        super();
        this.dimensionValue = 0;
        this.__scale = 1;
        this.lastVisibleState = null;
        //Listener for zoom change

        this.clickListener = cc.EventListener.create({
            event: cc.EventListener.TOUCH_ONE_BY_ONE,
            swallowTouches: false,
            onTouchBegan: this.onClick.bind(this)
        });
        this.moveListener = cc.EventListener.create({
            event: cc.EventListener.MOUSE,
            onMouseMove: (_event: any) => {
                if (this.isVisible()) {
                    var target = _event.getCurrentTarget();
                    var dim = target.dimensionLabel;
                    var s = dim.getContentSize();
                    var rect = cc.rect(0, 0, s.width, s.height);
                    var locationInNode = dim.convertToNodeSpace(_event.getLocation());
                    if (cc.rectContainsPoint(rect, locationInNode)) {
                        if (this.colorBack.a !== 0) {
                            this.colorBack.a = 0;
                            this.dimensionLabel.setColor(color ? color : new cc.Color(178, 174, 165));
                            this.dimensionLabel.disableStroke();
                            this.redraw();
                        }
                    } else {
                        if (this.colorBack.a !== 255) {
                            this.colorBack.a = 255;
                            this.dimensionLabel.setColor(new cc.Color(255, 255, 255));
                            this.dimensionLabel.enableStroke(color ? color : new cc.Color(178, 174, 165), 1);
                            this.redraw();
                        }
                    }
                    this.redraw();
                }
            }
        });

        this.addListeners();
        this.colorLine = color ? color : new cc.Color(178, 174, 165);
        this.colorLineBackground = color ? color : new cc.Color(178, 174, 165);
        this.colorBack = color ? color : new cc.Color(178, 174, 165);
        this.dimensionLabel.enableStroke(this.colorLine, 1);
        //Node state
        this.zoom = 1.0;
    }

    init(): boolean {
        if (super.init()) {
            var fontSize = 12;
            var labelSize = new cc.size(0, 13);
            var white = new cc.color(255, 255, 255);

            this.dimensionLabel = new cc.LabelTTF('', 'Roboto-Light', fontSize, labelSize, cc.TEXT_ALIGNMENT_CENTER, cc.TEXT_ALIGNMENT_CENTER);

            this.dimensionLabel.setName('TopLabel');
            this.dimensionLabel.setAnchorPoint(new cc.p(0.5, 0.5));
            this.dimensionLabel.setColor(white);
            //this.dimensionLabel.disableStroke();
            this.addChild(this.dimensionLabel);
            return true;
        }
        return false;
    }
    /**
     * Update value of dimensions
     * @param value (cm)
     * @param zoom
     */
    setDimensionValue(value: number, zoom: number) {
        if (value !== this.dimensionValue || zoom !== this.zoom) {
            this.dimensionValue = value;
            this.zoom = zoom;
            this.redraw();
        }
    }

    setLocalScale(value: number) {
        this.__scale = value;
        this.redraw();
    }

    setVisible(value: any) {
        super.setVisible(value);
        if (value) {
            this.redraw();
        }
    }

    setName(name: string) {
    		this._name = name;

        if (name === "Measure") {
            this.colorLine = new cc.Color(43, 130, 44);
            this.colorBack = new cc.Color(43, 130, 44);
        }
    }

    /**
     * Redraw node to process new values
     */
    redraw() {
        var planManagerAction = PlanManager.getInstance().getAction();

        if (planManagerAction === ActionStateEnum.SelectedOrderRoom || planManagerAction === ActionStateEnum.AbsoluteIdle ||
            planManagerAction === ActionStateEnum.idleCamera) {
            this.lastVisibleState = this.isVisible();
            this.setVisible(false);
        }
        else {
            if (this.lastVisibleState != null) {
                this.setVisible(this.lastVisibleState);
                this.lastVisibleState = null;
            }
        }

        if (!this.isVisible()) {
            return;
        }

        this.clear();

        this.dimensionLabel.setString(Math.round(this.dimensionValue / this.__scale));
        var clampedInvZoom = 1.0 / this.zoom;
        this.dimensionLabel.setScale(clampedInvZoom);
        this.dimensionLabel.setVisible(true);

        if ((this.dimensionLabel.getContentSize().width > this.dimensionValue * this.zoom * 0.80) || (this.zoom < 0.4 && this.dimensionValue < 130)) {
            this.dimensionLabel.setVisible(false);
        } else {
            this.drawSegment(new cc.p(-this.dimensionValue * 0.5, 0), new cc.p(-(this.dimensionLabel.getContentSize().width * 0.5 + 5) / this.zoom, 0), 1.0 / this.zoom, this.colorLine);
            this.drawSegment(new cc.p((this.dimensionLabel.getContentSize().width * 0.5 + 5) / this.zoom, 0), new cc.p(this.dimensionValue * 0.5, 0), 1.0 / this.zoom, this.colorLine);

            this.drawSegment(new cc.p(-this.dimensionValue * 0.5, -this.dimensionLabel.getContentSize().height * 0.5 / this.zoom), new cc.p(-this.dimensionValue * 0.5, this.dimensionLabel.getContentSize().height * 0.5 / this.zoom), 1.0 / this.zoom, this.colorLine);
            this.drawSegment(new cc.p(this.dimensionValue * 0.5, -this.dimensionLabel.getContentSize().height * 0.5 / this.zoom), new cc.p(this.dimensionValue * 0.5, this.dimensionLabel.getContentSize().height * 0.5 / this.zoom), 1.0 / this.zoom, this.colorLine);

            this.drawTextBackground();
        }
    }
    /**
     * Draw background of label
     */
    drawTextBackground() {
        var clampedInvZoom = 1.0 / this.zoom;

        var startPoint = new cc.p(-(this.dimensionLabel.getContentSize().width * 0.5 + 5) * clampedInvZoom, -this.dimensionLabel.getContentSize().height * 0.5 * clampedInvZoom);
        var endPoint = new cc.p((this.dimensionLabel.getContentSize().width * 0.5 + 5) * clampedInvZoom, this.dimensionLabel.getContentSize().height * 0.5 * clampedInvZoom);
        this.drawRect(startPoint, endPoint, this.colorBack, clampedInvZoom, this.colorLineBackground);
    }
    /**
     * Flip labels
     * @param value
     */
    setFlipped(value: any) {
        this.dimensionLabel.setFlippedY(value);
        this.dimensionLabel.setFlippedX(value);
    }
    /**
     * Add listener
     */
    addListeners() {
        cc.eventManager.addListener(this.clickListener, this);
        cc.eventManager.addListener(this.moveListener, this);
    }
    /**
     * Remove all attached listener
     */
    removeListeners() {
        cc.eventManager.removeListener(this.clickListener);
        cc.eventManager.removeListener(this.moveListener);
        eventsManager.instance.removeListener(this.scrollListener);
    }

    onClick(touch: any, _event: any): boolean {
        if (this.isVisible() && this.dimensionLabel.isVisible()) {
            var rect = this.dimensionLabel.getBoundingBoxToWorld();
            var location = touch.getLocation();
            if (cc.rectContainsPoint(rect, location)) {
                GameObjectManager.setObjectOfClickedDimension(this);
                return true;
            }
            //else {
            //    GameObjectManager.setObjectOfClickedDimension(null);
            //    return false;
            //}
        }
        return false;
    }

    editionStart() {
        this.colorBack.a = 255;
        this.colorLineBackground.a = 255;
        this.redraw();
    }

    editionEnd() {
        this.colorBack.a = 0;
        this.colorLineBackground.a = 0;
    }
    onEnter() {
        super.onEnter();
        this.scrollListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, (_event: any) => {
            this.setDimensionValue(this.dimensionValue, _event.getUserData());
        });

        /*this.stateListener = cc.EventListener.create({
         event: cc.EventListener.CUSTOM,
         eventName: Events.PLAN_STATE_CHANGED,
         onTouchBegan: this.redraw.bind(this)
         });*/

        /*        this.stateListener = new Listener(this.redraw.bind(this));
                eventsManager.instance.addListenerObject(Events.PLAN_STATE_CHANGED, this.stateListener);*/
    }
    onExit() {
        super.onExit();
        this.removeListeners();
    }
}

